<template>
    <div class="row text-left form--items" id="PersonalData">
        <div class="item--form col-12">
            <label for>
                <small>Tipo de pessoa</small>
            </label>
            <select
                id
                class="form-control"
                @change="userData.documentId = ''"
                v-model="userData.personType"
            >
                <option value="personal">Física</option>
                <option value="business">Jurídica</option>
            </select>
        </div>
        <div class="item--form col-12 mb-3">
            <label for="name">
                <small>Nome completo / Razão social</small>
            </label>
            <input
                type="text"
                id="name"
                v-model="userData.name"
                @blur="checkErrorName()"
                class="form-control"
            />
            <p class="errors" v-if="errors.name">{{errors.name}}</p>
        </div>
        <template v-if="userData.personType == 'personal'">
            <div class="item--form col-12">
                <label for="birthDate">
                    <small>Data de nascimento</small>
                </label>
                <input
                    type="date"
                    id="birthDate"
                    @blur="checkErrorBirthDate()"
                    v-model="userData.birthDate"
                    class="form-control"
                />
                <p class="errors" v-if="errors.birthDate">{{errors.birthDate}}</p>
            </div>
            <div class="item--form col-12 mb-3">
                <label for="cpf">
                    <small>CPF</small>
                </label>
                <input
                    type="tel"
                    id="cpf"
                    v-mask="'###.###.###-##'"
                    @blur="checkErrorDocumentId()"
                    v-model="userData.documentId"
                    class="form-control"
                />
                <p class="errors" v-if="errors.documentId">{{errors.documentId}}</p>
            </div>
        </template>
        <template v-else>
            <div class="item--form col-12 mb-3">
                <label for="responsible">
                    <small>Nome do responsável</small>
                </label>
                <input
                    id="responsible"
                    type="text"
                    @blur="checkErrorResponsible()"
                    v-model.trim="userData.responsible"
                    class="form-control"
                />
                <p class="errors" v-if="errors.responsible">{{errors.responsible}}</p>
            </div>
            <div class="item--form col-12 mb-3">
                <label for="cnpj">
                    <small>CNPJ</small>
                </label>
                <input
                    type="tel"
                    id="cnpj"
                    v-mask="'##.###.###/####-##'"
                    @blur="checkErrorDocumentId()"
                    v-model="userData.documentId"
                    class="form-control"
                />
                <p class="errors" v-if="errors.documentId">{{errors.documentId}}</p>
            </div>
        </template>
        <div class="item--form col-12 mb-3">
            <label for="phone">
                <small>Telefone (DDD + Número)</small>
            </label>
            <input
                type="tel"
                id="phone"
                v-mask="'(##)#####-####'"
                @blur="checkErrorPhone()"
                v-model="userData.phone"
                class="form-control"
            />
            <p class="errors" v-if="errors.phone">{{errors.phone}}</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "PersonalData",
    data: () => {
        return {
            listErrors: [],
            planSelection: false,
            article: {
                title: "",
                description: "",
            },
            errors: {},
        }
    },
    props: {
        typePayment:{
            required: true
        },
        userData:{
            required: true
        },
    },
    methods:{
        checkErrorName(){
            if(this.userData.personType == 'personal'){
                const regex = /\W|_/;

                if (!this.userData.name )
                    this.$set(this.errors, 'name', "Nome Completo obrigatório");
                else if (!regex.test(this.userData.name) && this.userData.name.length < 3)
                    this.$set(this.errors, 'name', "Nome inválido");
                else
                    this.$delete(this.errors,'name');
            }
            else this.$delete(this.errors,'name');
        },
        checkErrorDocumentId(){
			if (!this.userData.documentId)
                this.$set(this.errors, 'documentId', "CPF/CNPJ obrigatório");
            else
                this.$delete(this.errors,'documentId');

            if (this.userData.personType == "personal" && this.userData.documentId)
                if(this.validaCpf())
                    this.$delete(this.errors,'documentId');
                else
                    this.$set(this.errors, 'documentId', "CPF inválido");

            if (this.userData.personType == "business" && this.userData.documentId)
                if(this.validaCnpj())
                    this.$delete(this.errors,'documentId');
                else
                    this.$set(this.errors, 'documentId', "CNPJ inválido");

        },
        checkErrorResponsible(){
            if (!this.userData.responsible && this.userData.personType == "business")
                this.$set(this.errors, 'responsible', "Nome do responsável obrigatório");
            else this.$delete(this.errors,'responsible');
        },
        checkErrorPhone(){
            if (!this.userData.phone)
                this.$set(this.errors, 'phone', "Telefone obrigatório");
            else
                this.$delete(this.errors,'phone');
        },
        checkErrorBirthDate(){
           if (!this.userData.birthDate && this.userData.personType == 'personal')
                this.$set(this.errors, 'birthDate', "Data de nascimento obrigatória");

            else
                this.$delete(this.errors,'birthDate');
        },
        checkError(){
            this.checkErrorName();
            this.checkErrorDocumentId();
            this.checkErrorResponsible();
            this.checkErrorPhone();
            this.checkErrorBirthDate();

            this.$emit('errorNumbers',Object.keys(this.errors).length)
        },
        checkCpf() {
            if (this.userData.personType == "personal") {
                if (this.validaCpf() == false) {
                    if (this.listErrors.some((err) => err == "CPF inválido") == false) {
                        this.listErrors.push("CPF inválido");
                    }
                } else {
                    let errorPosition = this.listErrors.findIndex(
                        (err) => err == "CPF inválido"
                    );
                    if (errorPosition >= 0) {
                        this.listErrors.splice(errorPosition, 1);
                    }
                }
            }
        },
        validaCpf() {
            var Soma;
            var Resto;
            Soma = 0;
            if(this.userData.documentId){
                let strCPF = this.userData.documentId;
                strCPF = strCPF.replace(/[^\d]+/g, "");
                if (strCPF == "00000000000") return false;
                for (let i = 1; i <= 9; i++)
                    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
                Resto = (Soma * 10) % 11;
                if (Resto == 10 || Resto == 11) Resto = 0;
                if (Resto != parseInt(strCPF.substring(9, 10))) return false;
                Soma = 0;
                for (let i = 1; i <= 10; i++)
                    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
                Resto = (Soma * 10) % 11;
                if (Resto == 10 || Resto == 11) Resto = 0;
                if (Resto != parseInt(strCPF.substring(10, 11))) return false;
                return true;
            }
        },
	    checkCnpj() {
            if (this.userData.personType == "business") {
                if (validaCnpj(this.userData.documentId) == false) {
                    if (this.listErrors.some((err) => err == "CNPJ inválido") == false) {
                        this.listErrors.push("CNPJ inválido");
                    }
                } else {
                    let errorPosition = this.listErrors.findIndex(
                        (err) => err == "CNPJ inválido"
                    );
                    if (errorPosition >= 0) {
                        this.listErrors.splice(errorPosition, 1);
                    }
                }
            }
	    },
	    validaCnpj() {
            let value = this.userData.documentId
            value = value.replace(/\D/g, '')
            value = value.padStart(14, '0')

            if (this.isExceptionCnpj(value))
                return false

            if (!this.isValidCnpjNumber(value))
                return false

            if (
                this.calculateRestCnpj(
                    this.sumCnpjDigit(value, 12)
                ) !=
                parseInt(value.substring(12, 13))
            ) {
                return false
            }

            if (
                this.calculateRestCnpj(
                    this.sumCnpjDigit(value.substring(0, 13), 13)
                ) !=
                parseInt(value.substring(13, 14))
            ) {
                return false
            }

            return true
        },
	    isExceptionCnpj(value) {
            var lstCpfException = new Array(
                    '00000000000000',
                    '11111111111111',
                    '22222222222222',
                    '33333333333333',
                    '44444444444444',
                    '55555555555555',
                    '66666666666666',
                    '77777777777777',
                    '88888888888888',
                    '99999999999999'
            )

            return lstCpfException.includes(value)
        },
	    isValidCnpjNumber(value) {
            if (value == '' || value === undefined || value === null || value.legth < 14)
                    return false

            return true
        },
        sumCnpjDigit(value, length) {
            var pos = length - 7
            var sumDigit = 0

            for (var i = length; i >= 1; i--) {
                    sumDigit += value.charAt(length - i) * pos--
                    if (pos < 2)
                            pos = 9
            }

            return sumDigit
        },
        calculateRestCnpj(value) {
            return value % 11 < 2 ? 0 : 11 - value % 11
        },
        isValidCnpjNumber(value) {
            if (value == '' || value === undefined || value === null || value.legth < 14){
                    return false}

            return true
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/organisms/CheckoutStepPersonalData.vue